import base from "../base.js";

export default class Shadow extends base {
    objectType = "Shadow";
    _Color = "";
    Direction = 0.0;
    ShadowDepth = 0.0;
    BlurRadius = 0.0;

    constructor(args = {}) {
        super(args);
        this.objectToClassValue({...args, canBeHide: false, show: false});

    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Color = args.color ? args.color : "#000000";
        this.Direction = args.direction ? args.direction : 270;
        this.ShadowDepth = args.shadowDepth ? args.shadowDepth : 7;
        this.BlurRadius = args.blurRadius ? args.blurRadius : 10;
        this.CanChangeName = false;
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Direction", construct: Number, jsType: "Number" },
            { property: "ShadowDepth", construct: Number, jsType: "Number" },
            { property: "BlurRadius", construct: Number, jsType: "Number" },
            { property: "Color", construct: String, jsType: "String" }
        ];
    }

    get addedElementShortCutAction() {
        return [
            ...super.addedElementShortCutAction,
            { name: "Color", type: "colorInput", dataType: "string", description: "Changer la couleur", svgComponentIcon: "colorIcon" },
        ];
    }

    get shortCut() {
        return [
            ...super.shortCut,
            { name: "Color", type: "colorInput", dataType: "string", description: "Changer la couleur", svgComponentIcon: "colorIcon" },
        ];
    }

    get Color() {
        return this._Color;
    }

    set Color(value) {
        this._Color = this.harmonizeColorValue(value);
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            {name:"Color", text: "Couleur", type:"colorInput", dataType: "string"},
            {name:"Direction", text: "Direction", type:"numberInput", dataType: "number"},
            ...(this.parent?.objectType == 'TextMedia' ? [] : [{name:"ShadowDepth", text: "Profondeur", type:"numberInput", dataType: "number"}]),
            {name:"BlurRadius", text: "Rayon", type:"numberInput", dataType: "number"},
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }

    static get Name() {
        return "Ombre";
    }

    get RGBAColor() {
        const rgb = this.Color.startsWith("#") ? this.hexStringToRgbaObject(this.Color) : this.RgbaStringToRgbaObject(this.Color);
        
        if (rgb) {
            return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`;
        }
        return "rgba(0, 0, 0, 0)";
    }

    getShadowStyle(type="textShadow") {
        let degree = Math.PI / 180 * this.Direction;
        let x = Math.round(Math.cos(-degree) * this.BlurRadius);
        let y = Math.round(Math.sin(-degree) * this.BlurRadius);
        let radius = {};
        if (this.parent.objectType == "ColorMedia") {
            radius.borderRadius = `${this.parent.RadiusTopLeft}px ${this.parent.RadiusTopRight}px ${this.parent.RadiusBottomLeft}px ${this.parent.RadiusBottomRight}px`;
        }
        if (type === "textShadow") {
            return { ...radius, [type]: `${x}px ${y}px ${this.BlurRadius}px ${this.RGBAColor}` };
        }
        else {
            return { ...radius, [type]: `${x}px ${y}px ${this.BlurRadius}px ${this.ShadowDepth}px ${this.RGBAColor}` };
        }
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            color: this.hexColorValue(this.Color),
            direction: this.Direction,
            shadowDepth: this.ShadowDepth,
            blurRadius: this.BlurRadius
        }
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            color: this.Color,
            direction: this.Direction,
            shadowDepth: this.ShadowDepth,
            blurRadius: this.BlurRadius
        }
    }
}
